import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aa66170"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Notes", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ctrl-G", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Shift-A", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Alt-A", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editor_content = _resolveComponent("editor-content")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("article", null, [
      _createVNode(_component_editor_content, {
        editor: _ctx.editor,
        class: "pt-2",
        style: { 'max-width': '60ch' }
      }, null, 8, ["editor"])
    ]),
    _createElementVNode("aside", null, [
      _hoisted_1,
      _createTextVNode(" Loosely inspired by figma's "),
      _hoisted_2,
      _createTextVNode(" and "),
      _hoisted_3,
      _createTextVNode(" Select some text and press "),
      _hoisted_4,
      _createTextVNode(" to wrap it into a note. "),
      _hoisted_5,
      _createTextVNode(" Drag one note on top of another to set them next to each other "),
      _hoisted_6,
      _createTextVNode(" or... press: "),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.wrapNote && _ctx.wrapNote(...args)))
      }, "wrap into note")
    ])
  ]))
}